import Vue from 'vue'
import VueRouter from 'vue-router'

import { authGuard } from "@/auth/authGuard";

import MainLayout from '@/ui/layouts/MainLayout'
// import HomeView from '@/ui/views/HomeView'
import DashboardView from '@/ui/views/DashboardView'
import SinglePageView from '@/ui/views/SinglePageView'
import AuthGuard from '@/ui/controls/AuthGuard'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '/',
        redirect: { name: 'dashboard' },
      },
      {
        path: '/home',
        name: 'home',
        redirect: { name: 'dashboard' },
      },
      {
        path: 'dashboard/:dashboardName?',
        name: 'dashboard',
        props: true,
        component: DashboardView,
        // children: [
        //   {
        //     path: '',
        //     // beforeEnter: authGuard,
        //     component: () => import('@/ui/components/DashboardComponent'),
        //   }
        // ]
      },
      {
        path: '',
        // component: DashboardView,
        component: SinglePageView,
        children: [
          {
            path: '',
            component: AuthGuard,
            children: [
              {
                path: 'table',
                name: 'table',
                // props: { narrow: true },
                component: () => import('@/ui/components/ItemsTableComponent'),
              },
    
              {
                path: 'profile',
                name: 'profile',
                beforeEnter: authGuard,
                component: () => import('@/ui/components/users/ProfileComponent')
              },
            ],
          }
        ]
      },
      {
        path: 'items',
        component: SinglePageView,
        beforeEnter: authGuard,
        children: [
          {
            path: ':itemId',
            name: 'item-view',
            props: true,
            component: () => import('@/ui/components/ItemComponent')
          },
          {
            path: '/:itemId/edit',
            name: 'item-edit',
            props: true,
            component: () => import('@/ui/components/ItemEditComponent')
          },
          {
            path: '/:itemId/delete',
            name: 'item-delete',
            props: true,
            component: () => import('@/ui/components/ItemDeleteComponent')
          },
        ]
      },
    ],
  },
  {
    path: '/about',
    name: 'about',
    // component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    component: () => import('@/ui/views/About')
  },

  // {
  //   path: '/login',
  //   name: 'login',
  //   redirect: () => 
  // }

  { path: '*', name: 'not-found', component: () => import('@/ui/NotFound') },
]

const router = new VueRouter({
  // base: '/stracker/',
  base: process.env.VUE_APP_PUBLIC_PATH,
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
        // , offset: { x: 0, y: 10 }
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

export default router
